export default __webpack_public_path__ + "static/fractions_dark-d4e122fdb3d5ebc5d757f1c6a2fb745b.png";